import React from 'react';
import { ButtonProps, styled } from '@mui/material';
import { CollapsableCardButton } from './CollapsableCardButton';
import { CollapsableCardHeaderItem } from './CollapsableCardHeaderItem';

interface CollapsableCardHeaderItemButtonProps extends Omit<ButtonProps, 'variant'> {
  label: string;
}

const TopMarginCollapsableCardHeaderItem = styled(CollapsableCardHeaderItem)(() => ({
  marginTop:'1.5em'
}));

const TopMarginCollapsableCardButton = styled(CollapsableCardButton)(() => ({
  maxWidth: 'fit-content'
}));


const CollapsableCardHeaderItemButton = ({
  label,  ...rest
}: CollapsableCardHeaderItemButtonProps) => {
  return (
      <TopMarginCollapsableCardHeaderItem
        label=""
        value={<TopMarginCollapsableCardButton
          label={label}
          {...rest}
        />}
      />
  );
};

export { CollapsableCardHeaderItemButton };
